/// <reference path="../../lib/app.d.ts" />

import {WelcomeLayer} from "./welcome-layer";

interface StreamNotification
{
	contents : any;
	timeout : number;

	$node ?: JQuery;
	timer ?: number;
}

export class StreamNotificationManager
{
	TAG = "[Sxc.Chat.StreamNotificationManager]";

	private notifications : Array<StreamNotification> = [];

	public onClick : Function;
	public onOpen : Function;
	public onClose : Function;

	constructor(private $root, private welcome : WelcomeLayer)
	{

	}

	/**
	 * Adds a new Notification, and show it if it's possible.
	 */
	add(
		contents : JQuery | string,
		theme : string,
		tag : string,
		timeout = null, onClick : Function
	)
	{
		const $node = $("<div class='sxcc-stream-notification' />").append(
			$("<div class='sxcc-stream-notification-contents' />").append(contents),
			$("<div class='sxcc-stream-notification-close' />")
		);

		let notif : StreamNotification = {
			contents,
			timeout,
			$node
		};

		$node.attr("data-tag", tag);
		$node.addClass("sxcc-stream-notification-theme-" + theme);
		$node.find(".sxcc-stream-notification-close").on("click", (e) => {
			e.stopImmediatePropagation();
			this.clear(notif);
		});

		$node.data("notif", notif);

		$node.click(() => {
			if (onClick) {
				onClick();
				this.clear(notif);
			}
		});

		this.$root.append($node);

		this.welcome.fadeOut("stream-notification");

		if (timeout) {
			notif.timer = setTimeout(() => {
				this.clear(notif);
			}, timeout);
		}
	}

	fadeOut() {
		this.$root.addClass("sxc-faded");
	}

	fadeIn() {
		this.$root.removeClass("sxc-faded");
	}

	clearByTag(tag : string)
	{
		this.$root.find("[data-tag=" + tag + "]").each((i, e) => {
			this.clear($(e).data("notif"));
		});
	}

	//noinspection JSMethodCanBeStatic
	private clear(notif : StreamNotification)
	{
		notif.$node.remove();
		this.welcome.fadeIn("stream-notification");
		clearTimeout(notif.timer);
	}

	setSize(size: string, rightMargin : number)
	{
		this.$root.removeClass("sxcct-size-fs sxcct-size-normal");
		this.$root.addClass("sxcct-size-" + size);
		this.$root.css({
			right: rightMargin,
		});
	}
}
